import React from 'react';
import * as FaIcons from 'react-icons/fa';
import * as AiIcons from 'react-icons/ai';
import * as IoIcons from 'react-icons/io';
import * as RiIcons from 'react-icons/ri';

export const SideData = [
  {
    title: 'Dashboard',
    path: '/Dashboard',
    icon: <AiIcons.AiFillHome />,
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,

  },
  {
    title: 'Master',
    icon: <IoIcons.IoIosPaper />,
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,

    subNav: [
      {
        title: 'Firm Master',
        path: '/FirmEntry',
        icon: <IoIcons.IoIosPaper />,
        cName: 'sub-nav'
      },
      {
        title: 'Employee Master',
        path: '/EmployeeEntry',
        icon: <IoIcons.IoIosPaper />,
        cName: 'sub-nav'
      },
      {
        title: 'Team Leader Master',
        path: '/team-leader-entry',
        icon: <IoIcons.IoIosPaper />,
        cName: 'sub-nav'
      },
      {
        title: 'Cloth Master',
        path: '/ClothEntry',
        icon: <IoIcons.IoIosPaper />,
        cName: 'sub-nav'
      },
      {
        title: 'Sale & Purchase Party',
        path: '/SalePurchaseEntry',
        icon: <IoIcons.IoIosPaper />,
        cName: 'sub-nav'
      },
      {
        title: 'Vendor Master',
        path: '/VendorEntry',
        icon: <IoIcons.IoIosPaper />,
        cName: 'sub-nav'
      },
       {
        title: 'Salesman Master',
        path: '/SalesmanEntry',
        icon: <IoIcons.IoIosPaper />,
        cName: 'sub-nav'
      },
       {
        title: 'Guaranteer Master',
        path: '/GuaranteerEntry',
        icon: <IoIcons.IoIosPaper />,
        cName: 'sub-nav'
      },
      {
        title: 'Sample Price Master',
        path: '/SampleEntry',
        icon: <IoIcons.IoIosPaper />,
        cName: 'sub-nav'
      },
      
      {
        title: 'Item Master',
        path: '/ItemEntry',
        icon: <IoIcons.IoIosPaper />,
        cName: 'sub-nav'
      },
      {
        title: 'Department Master',
        path: '/DepartmentEntry',
        icon: <IoIcons.IoIosPaper />,
        cName: 'sub-nav'
      },
      {
        title: 'Panna Master',
        path: '/PannaEntry',
        icon: <IoIcons.IoIosPaper />,
        cName: 'sub-nav'
      },
      // {
      //   title: 'Item Average Master',
      //   path: '/ItemAverageMaster',
      //   icon: <IoIcons.IoIosPaper />,
      //   cName: 'sub-nav'
      // },
      {
        title: 'Rack Master',
        path: '/RackEntry',
        icon: <IoIcons.IoIosPaper />,
        cName: 'sub-nav'
      },
      {
        title: 'School Master',
        path: '/SchoolEntry',
        icon: <IoIcons.IoIosPaper />,
        cName: 'sub-nav'
      },
      {
        title: 'Transport Master',
        path: '/TransportEntry',
        icon: <IoIcons.IoIosPaper />,
        cName: 'sub-nav'
      },
      {
        title: 'Logo Master',
        path: '/LogoEntry',
        icon: <IoIcons.IoIosPaper />,
        cName: 'sub-nav'
      },
      {
        title: 'Material Master',
        path: '/MaterialEntry',
        icon: <IoIcons.IoIosPaper />,
        cName: 'sub-nav'
      },
      {
        title: 'Brand Entry',
        path: '/brand-entry',
        icon: <IoIcons.IoIosPaper />,
        cName: 'sub-nav'
      },
      {
        title: 'Location Entry',
        path: '/location-entry',
        icon: <IoIcons.IoIosPaper />,
        cName: 'sub-nav'
      }
    ]
  },
  {
    title: 'Attendance',
    icon: <IoIcons.IoIosPaper />,
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,

    subNav: [
      {
        title: 'Employee Attendance',
        path: '/employee-attendance',
        icon: <IoIcons.IoIosPaper />,
        cName: 'sub-nav'
      },
    ]
  },

  {
    title: 'Cloth Stock',
    icon: <IoIcons.IoIosPaper />,
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,

    subNav: [
      {
        title: 'Cloth Stock Entry',
        path: '/manual-cloth-stock',
        icon: <IoIcons.IoIosPaper />,
        cName: 'sub-nav'
      },
      // {
      //   title: 'Ready Made Stock',
      //   path: '/ReadyMStkEntry',
      //   icon: <IoIcons.IoIosPaper />,
      //   cName: 'sub-nav'
      // }
    ]
  },
  {
    title: 'Quotation',
    icon: <IoIcons.IoIosPaper />,
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,

    subNav: [
       {
        title: 'Quotation',
        path: '/quotation-entry',
        icon: <IoIcons.IoIosPaper />,
        cName: 'sub-nav'
      },
      
    ]
  },
  
  {
    title: 'Sale Order',
    icon: <IoIcons.IoIosPaper />,
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,

    subNav: [
      // {
      //   title: 'Price Percentage Group',
      //   path: '/PricePercentGEntry',
      //   icon: <IoIcons.IoIosPaper />,
      //   cName: 'sub-nav'
      // },
      // {
      //   title: 'Quotation',
      //   path: '/quotation-entry',
      //   icon: <IoIcons.IoIosPaper />,
      //   cName: 'sub-nav'
      // },
      {
        title: 'Sale Order',
        path: '/SOSampleEntry',
        icon: <IoIcons.IoIosPaper />,
        cName: 'sub-nav'
      },
    ]
  },
  {
    title: 'Purchase',
    icon: <IoIcons.IoIosPaper />,
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,

    subNav: [
      {
        title: 'Cloth Purchase Order',
        path: '/PurchaseOrderEntry',
        icon: <IoIcons.IoIosPaper />,
        cName: 'sub-nav'
      },
      
            {
              title: 'Material Purchase Order',
              path: '/material-po-entry',
              icon: <IoIcons.IoIosPaper />,
              cName: 'sub-nav'
            },
      // {
      //   title: 'Purchase Inward',
      //   path: '/PurchaseInwardEntry',
      //   icon: <IoIcons.IoIosPaper />,
      //   cName: 'sub-nav'
      // },

    ]
  },
  // {
  //   title: 'Inward',
  //   icon: <IoIcons.IoIosPaper />,
  //   iconClosed: <RiIcons.RiArrowDownSFill />,
  //   iconOpened: <RiIcons.RiArrowUpSFill />,

  //   subNav: [
  //     {
  //       title: 'Purchase Inward',
  //       path: '/PurchaseInwardEntry',
  //       icon: <IoIcons.IoIosPaper />,
  //       cName: 'sub-nav'
  //     },


  //   ]
  // },
  // {
  //   title: 'Worker Master',
  //   icon: <IoIcons.IoIosPaper />,
  //   iconClosed: <RiIcons.RiArrowDownSFill />,
  //   iconOpened: <RiIcons.RiArrowUpSFill />,

  //   subNav: [
  //     {
  //       title: 'Category',
  //       path: '/CategoryMaster',
  //       icon: <IoIcons.IoIosPaper />,
  //       cName: 'sub-nav'
  //     },

  //   ]
  // },
  {
    title: 'Cutting',
    icon: <IoIcons.IoIosPaper />,
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,

    subNav: [
      {
        title: 'Cloth Issue',
        path: '/ClothIssueEntry',
        icon: <IoIcons.IoIosPaper />,
        cName: 'sub-nav'
      },
      {
        title: 'Cutting Entry',
        path: '/cutting-entry',
        icon: <IoIcons.IoIosPaper />,
        cName: 'sub-nav'
      }
    ]
  },
  // {
  //   title: 'Numbering',
  //   icon: <IoIcons.IoIosPaper />,
  //   iconClosed: <RiIcons.RiArrowDownSFill />,
  //   iconOpened: <RiIcons.RiArrowUpSFill />,

  //   subNav: [
  //     {
  //       title: 'Numbering',
  //       path: '/numbering-entry',
  //       icon: <IoIcons.IoIosPaper />,
  //       cName: 'sub-nav'
  //     }
  //   ]
  // },
  // {
  //   title: 'Fusioning',
  //   icon: <IoIcons.IoIosPaper />,
  //   iconClosed: <RiIcons.RiArrowDownSFill />,
  //   iconOpened: <RiIcons.RiArrowUpSFill />,

  //   subNav: [
  //     {
  //       title: 'Fusioning',
  //       path: '/fusioning-entry',
  //       icon: <IoIcons.IoIosPaper />,
  //       cName: 'sub-nav'
  //     }
  //   ]
  // },
  {
    title: 'Stitching',
    icon: <IoIcons.IoIosPaper />,
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,

    subNav: [
      {
        title: 'Stitching Entry',
        path: '/StitchInhouseEntry',
        icon: <IoIcons.IoIosPaper />,
        cName: 'sub-nav'
      }
    ]
  },
  // {
  //   title: 'Kaje-Press(Iron)',
  //   icon: <IoIcons.IoIosPaper />,
  //   iconClosed: <RiIcons.RiArrowDownSFill />,
  //   iconOpened: <RiIcons.RiArrowUpSFill />,

  //   subNav: [
  //     {
  //       title: 'Kaje-Press(Iron) Issue/Inward',
  //       path: '/Kaje-PressIssueInward',
  //       icon: <IoIcons.IoIosPaper />,
  //       cName: 'sub-nav'
  //     }
  //   ]
  // },
  {
    title: 'Kaje',
    icon: <IoIcons.IoIosPaper />,
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,

    subNav: [
      {
        title: 'Kaje Entry',
        path: '/KajeEntry',
        icon: <IoIcons.IoIosPaper />,
        cName: 'sub-nav'
      }
    ]
  },
  // {
  //   title: 'Trimming',
  //   icon: <IoIcons.IoIosPaper />,
  //   iconClosed: <RiIcons.RiArrowDownSFill />,
  //   iconOpened: <RiIcons.RiArrowUpSFill />,

  //   subNav: [
  //     {
  //       title: 'Trimming Entry',
  //       path: '/trimming-entry',
  //       icon: <IoIcons.IoIosPaper />,
  //       cName: 'sub-nav'
  //     }
  //   ]
  // },

  {
    title: 'Press',
    icon: <IoIcons.IoIosPaper />,
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,

    subNav: [
      {
        title: 'Pressing Entry',
        path: '/pressing-entry',
        icon: <IoIcons.IoIosPaper />,
        cName: 'sub-nav'
      }
    ]
  },
  // {
  //   title: 'Transport Bail',
  //   icon: <IoIcons.IoIosPaper />,
  //   iconClosed: <RiIcons.RiArrowDownSFill />,
  //   iconOpened: <RiIcons.RiArrowUpSFill />,

  //   subNav: [
  //     {
  //       title: 'Transport Bail Entry',
  //       path: '/TransportBailEntry',
  //       icon: <IoIcons.IoIosPaper />,
  //       cName: 'sub-nav'
  //     }
  //   ]
  // },
  // {
  //   title: 'Printing',
  //   icon: <IoIcons.IoIosPaper />,
  //   iconClosed: <RiIcons.RiArrowDownSFill />,
  //   iconOpened: <RiIcons.RiArrowUpSFill />,

  //   subNav: [
  //     {
  //       title: 'Printing Outward Entry',
  //       path: '/PrintingOutwardEntry',
  //       icon: <IoIcons.IoIosPaper />,
  //       cName: 'sub-nav'
  //     }
  //   ]
  // },
  {
    title: 'Stock',
    icon: <IoIcons.IoIosPaper />,
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,

    subNav: [
      // {
      //   title: 'Stock Entry',
      //   path: '/StockEntry-Production',
      //   icon: <IoIcons.IoIosPaper />,
      //   cName: 'sub-nav'
      // },
      {
        title: 'Stock Production Entry',
        path: '/StkProductionEntry',
        icon: <IoIcons.IoIosPaper />,
        cName: 'sub-nav'
      }
    ]
  },
  {
    title: 'Job Work',
    icon: <IoIcons.IoIosPaper />,
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,

    subNav: [
      {
        title: 'Jobwork Entry',
        path: '/jobwork-entry',
        icon: <IoIcons.IoIosPaper />,
        cName: 'sub-nav'
      },

    ]
  },
  {
    title: 'Packing',
    icon: <IoIcons.IoIosPaper />,
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,

    subNav: [
      {
        title: 'Packing ',
        path: '/packing-entry',
        icon: <IoIcons.IoIosPaper />,
        cName: 'sub-nav'
      },

    ]
  },
  {
    title: 'Receipt',
    icon: <IoIcons.IoIosPaper />,
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,

    subNav: [
      {
        title: 'Sale Receipt Entry',
        path: '/Sale-Receipt-Entry',
        icon: <IoIcons.IoIosPaper />,
        cName: 'sub-nav'
      },

    ]
  },
  {
    title: 'Report',
    icon: <IoIcons.IoIosPaper />,
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,

    subNav: [
      {
        title: 'Sale Ledger Statement',
        path: '/Sale-ledger-statement',
        icon: <IoIcons.IoIosPaper />,
        cName: 'sub-nav'
      },

    ]
  },
  // {
  //   title: 'Invoice',
  //   icon: <IoIcons.IoIosPaper />,
  //   iconClosed: <RiIcons.RiArrowDownSFill />,
  //   iconOpened: <RiIcons.RiArrowUpSFill />,

  //   subNav: [
  //     {
  //       title: 'Invoice Entry',
  //       path: '/invoice-entry',
  //       icon: <IoIcons.IoIosPaper />,
  //       cName: 'sub-nav'
  //     },

  //   ]
  // },
  {

  }

];